import React, { useEffect, useState, useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { authenActions } from "../store/authen-slice";
import MenuDropdown from "./trangchu/MenuDropdown";
import MenuUserDropdown from "./trangchu/MenuUserDropdown";
import AuthContext from "../contexts/JWTAuthContext";
import { subscribe, unsubscribe } from "../customEvents";
import { uiActions } from "../store/ui-slice";
import { placeCartActions } from "../store/placeCart-slice";
import { getTranslation } from "../lang.js";

const dropdownThongTin = [

  {
    routePath: "chuong-trinh-khuyen-mai",
    routeTitle: "Khuyến mãi",
  },
  {
    routePath: "noi-quy",
    routeTitle: "Nội quy tham gia",
  },
  {
    routePath: "thoi-gian-tham-quan",
    routeTitle: "Thời gian tham quan",
  },
  {
    routePath: "tour-moi",
    routeTitle: "Chương trình tour mới",
  },
  {
    routePath: "lich-su-mua-ve",
    routeTitle: "Tra cứu vé",
  },
];

const MainHeader = (props) => {
  const API_URL = process.env.REACT_APP_URL;
  const dispatch = useDispatch();
  const { isAuthenticated, user, isInCms, isInitialised } =
    useContext(AuthContext);
  const [userRoleId, setUserRoleId] = useState(-1);
  const [showMenu, setShowMenu] = useState(false);
  const [menus, setMenus] = useState([]);
  const history = useNavigate();

  const [isHoverLang, setIsHoverLang] = useState(false);
  const [isShowLang, setIsShowLang] = useState(false);

  const language = localStorage.getItem("language") || "vi";
  const paragramdict = getTranslation(1, language, 0);
  const variabledict = getTranslation(1, language, 1);

  const dropdownThongTinOther = [

    {
      routePath: "noi-quy",
      routeTitle: paragramdict[9],
    },
    {
      routePath: "thoi-gian-tham-quan",
      routeTitle: paragramdict[10]
    },
    {
      routePath: "lich-su-mua-ve",
      routeTitle: paragramdict[11],
    },
  ];

  useEffect(() => {
    const curStrUser = localStorage.getItem("user");
    const curUser = JSON.parse(curStrUser);
    const curRoleId = (curUser && curUser.roleid) || -1;
    setUserRoleId(curRoleId);
  }, [userRoleId, isAuthenticated]);

  const logoutHandler = (evt) => {
    dispatch(authenActions.logout());
  };

  const showHandler = (evt) => {
    setShowMenu(!showMenu);
  };

  const hideMenu = () => {
    setShowMenu(false);
  };

  const clickNgonNgu = (value) => {
    localStorage.setItem("language", value);
  };

  useEffect(() => {


    fetch(`${API_URL}/api/menu/getheader/${(user && user.username) || ""}`)
      .then((res) => res.json())
      .then((data) => {
        setMenus(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [isAuthenticated]);

  useEffect(() => {
    if (
      isAuthenticated &&
      isInitialised &&
      user &&
      user.roleid &&
      user.roleid === 3
    ) {
      dispatch(uiActions.setShowSelectDefaultPlace(true));
    } else {
      dispatch(placeCartActions.setDefaultTicketType(1));
      dispatch(uiActions.setShowSelectDefaultPlace(false));
    }
  }, [isAuthenticated, isInitialised]);

  useEffect(() => {
      let mTimeOut = null;
      if (isHoverLang) {
        setIsShowLang(true);
      } else {
        mTimeOut = setTimeout(() => {
          setIsShowLang(false);
        }, 500);
      }
      return () => {
        if (mTimeOut) {
          clearTimeout(mTimeOut);
        }
      };
    }, [isHoverLang]);

  useEffect(() => {
    subscribe("changeLoginState", (data) => {
      if (data.detail.isLogin && data.detail.roleId === 4) {
        history("/ticket-scan");
      } else {
        history("/vedientu");
      }
    });
    subscribe("changeCurrentPage", (data) => {
      setShowMenu(false);
    });
    return () => {
      unsubscribe("changeLoginState");
      unsubscribe("changeCurrentPage");
    };
  }, []);

  return (
    <nav
      className={`navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light ${
        isInCms ? "d-none" : ""
      }`}
      id="ftco-navbar"
    >
      <div className="container">
        <Link className="navbar-brand" to={"/vedientu"}>
          <img
            src={variabledict[15]}
            alt="img-fluid"
          />
        </Link>
        <button
          className={`${
            showMenu ? "navbar-toggler" : "navbar-toggler collapsed"
          }`}
          type="button"
          data-toggle="collapse"
          data-target="#ftco-nav"
          aria-controls="ftco-nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={showHandler}
        >
          <span className="oi oi-menu"></span>
        </button>

        <div
          className={`${
            showMenu
              ? "collapse navbar-collapse show"
              : "collapse navbar-collapse"
          }`}
          id="ftco-nav"
        >
          <ul className="navbar-nav">
            {menus.map((el, idx) => {
              if (language != "vi") {
                if (el.isActiveEn == "1") {
                  if (el.isLeaf === "0") {
                    return (
                      <MenuDropdown
                        key={idx}
                        arrDropdownItem={dropdownThongTinOther}
                        dropdownId={`menu_header_${el.id}`}
                        title={el[variabledict[12]]}
                        routePath={`home-page`}
                      />
                    );
                  }

                  return (
                    <li className="nav-item" key={idx}>
                      <NavLink
                        to={el.path}
                        className={(navData) => {
                          return navData.isActive ? "nav-link active" : "nav-link";
                        }}
                      >
                        {el[variabledict[12]]}
                      </NavLink>
                    </li>);
                }
              } else {
                  if (el.isLeaf === "0") {
                    return (
                      <MenuDropdown
                        key={idx}
                        arrDropdownItem={dropdownThongTin}
                        dropdownId={`menu_header_${el.id}`}
                        title={el.name}
                        routePath={`home-page`}
                      />
                    );
                  }
                  if (el.name === "CMS") {
                    return (
                      <li className="nav-item" key={idx}>
                        <a className="nav-link" href="/cms">
                          CMS
                        </a>
                      </li>
                    );
                  }
                  return (
                    <li className="nav-item" key={idx}>
                      <NavLink
                        to={el.path}
                        className={(navData) => {
                          return navData.isActive ? "nav-link active" : "nav-link";
                        }}
                      >
                        {el.name}
                      </NavLink>
                    </li>
                  );
              }
            })}
          </ul>
          <div className="action-nav">
            <ul>
              <li>
                <a className="cart" href="#">
                  <img src="images/icon/cart_white.png" alt="" />
                </a>
                {(!isAuthenticated ||
                  userRoleId === -1 ||
                  userRoleId === 5) && (
                  <Link className="cart show" to={"/gio-hang"}>
                    <img src="images/icon/cart_active.png" alt="" />
                  </Link>
                )}
              </li>
              <li>
                <div
                  className={`group-language ${isShowLang ? "show" : ""} ${isAuthenticated ? "d-none" : ""}`}
                >
                  <a href="#" className={`${language == "vi" ? "d-nones" : ""}`}>
                    <img
                      className={``}
                      src="images/icon/vi-VN.png"
                      alt=""
                      onClick={() => clickNgonNgu('vi')}
                    />
                  </a>
                  <a href="#" className={`${language == "en" ? "d-nones" : ""}`}>
                    <img
                    className={``}
                    src="images/icon/en-US.png"
                    alt=""
                    onClick={() => clickNgonNgu('en')}
                  />
                  </a>
                  <a href="#" className={`${language == "ko" ? "d-nones" : ""}`}>
                    <img
                    className={``}
                    src="images/icon/kr-KR.png"
                    alt=""
                    onClick={() => clickNgonNgu('ko')}
                  />
                  </a>
                </div>
                <div className="dropdown dropdown-language d-none">
                  <a
                    className="dropdown-toggle language-show"
                    href="#"
                    role="button"
                    id="dropdownlanguage"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img
                      className={`vi-vn active ${isAuthenticated ? "d-none" : ""}`}
                      src={
                        language == "vi"
                          ? "images/icon/vi-VN.png"
                          : language == "en" 
                          ? "images/icon/en-US.png"
                          : "images/icon/kr-KR.png"
                      }
                      alt=""
                    />
                    <img className="en-us" src="images/icon/en-US.png" alt="" />
                  </a>

                  <div
                    className="dropdown-menu language-dropdown"
                    aria-labelledby="dropdownlanguage"
                  >
                  </div>
                </div>
              </li>
              <MenuUserDropdown hideMenu={hideMenu} />
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};
export default MainHeader;
